// Дизайн-токены «Справочников» — скопированы 1:1 из референса заказчика
// (артефакт «Справочник товаров»). Значения дословные: hex, размеры шрифтов,
// стекло (blur/saturate), радиусы, тени, hover-состояния. НЕ подгонять на глаз —
// это эталон. Стили скоуплены под `.dir-scope`, чтобы не течь в остальной аппшелл.

/** Цвета для динамических инлайн-стилей (статусы, точки, чипы категорий). */
export const C = {
  ink: '#1E2A45',
  text: '#2B2F3A',
  green: '#3E8C6C',
  greenHover: '#34795E',
  amber: '#B26A16',
  red: '#C4525C',
  thActive: '#1E2A45',
  thIdle: 'rgba(30,42,74,0.55)',
  muted: 'rgba(30,42,74,0.6)',
  muted2: 'rgba(30,42,74,0.5)',
  faint: 'rgba(30,42,74,0.45)',
} as const;

export const FONT_STACK =
  'Manrope, -apple-system, BlinkMacSystemFont, sans-serif';

/** Фон страницы — два радиальных блика + диагональный градиент. */
export const PAGE_BG =
  'radial-gradient(circle at 12% 8%, rgba(120,175,255,0.30), transparent 46%), ' +
  'radial-gradient(circle at 88% 92%, rgba(255,181,110,0.26), transparent 50%), ' +
  'linear-gradient(160deg, #EEF2FC, #F8F6FF)';

const CSS = `
.dir-scope, .dir-scope input, .dir-scope button, .dir-scope select {
  font-family: ${FONT_STACK};
}
.dir-scope { -webkit-font-smoothing: antialiased; }
.dir-scope *::-webkit-scrollbar { width: 8px; height: 8px; }
.dir-scope *::-webkit-scrollbar-thumb { background: rgba(30,42,74,0.18); border-radius: 4px; }
.dir-scope *::-webkit-scrollbar-track { background: transparent; }

/* ── Шапка ── */
.dir-header {
  margin: 20px 32px 0; padding: 12px 16px; display: flex; align-items: center; gap: 12px;
  background: linear-gradient(160deg, rgba(255,255,255,0.55), rgba(255,255,255,0.25));
  backdrop-filter: blur(24px) saturate(160%); -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.7); border-radius: 16px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.5), 0 8px 24px rgba(30,42,74,0.08);
}
.dir-badge {
  width: 34px; height: 34px; border-radius: 10px; background: rgba(87,183,146,0.14);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0; color: #3E8C6C;
}
.dir-title { font-size: 15px; font-weight: 700; color: #1E2A45; }
.dir-subtitle { font-size: 11.5px; color: rgba(30,42,74,0.5); }
.dir-search {
  width: 340px; max-width: 100%; height: 36px; box-sizing: border-box;
  border: 1px solid rgba(255,255,255,0.65); border-radius: 10px; padding: 0 14px;
  font-size: 13px; color: #2B2F3A; background: rgba(255,255,255,0.55);
  backdrop-filter: blur(20px) saturate(150%); -webkit-backdrop-filter: blur(20px) saturate(150%);
  box-shadow: 0 2px 8px rgba(30,42,74,0.06); outline: none;
}
.dir-search::placeholder { color: rgba(43,47,58,0.45); }
.dir-btn {
  display: inline-flex; align-items: center; gap: 8px; height: 36px; padding: 0 16px;
  border: 1px solid rgba(255,255,255,0.65); border-radius: 10px; background: rgba(255,255,255,0.55);
  backdrop-filter: blur(20px) saturate(150%); -webkit-backdrop-filter: blur(20px) saturate(150%);
  box-shadow: 0 2px 8px rgba(30,42,74,0.06); color: #2B2F3A; font-size: 13px; font-weight: 500;
  cursor: pointer; white-space: nowrap;
}
.dir-btn--primary {
  border: none; background: #3E8C6C; color: #FFFFFF; font-weight: 600; gap: 5px; flex-shrink: 0;
}
.dir-btn--primary:hover { background: #34795E; }
.dir-btn--sm { height: 30px; padding: 0 12px; font-size: 12.5px; }
.dir-iconbtn {
  width: 30px; height: 30px; border: 1px solid rgba(30,42,74,0.14); border-radius: 8px;
  background: #F8F7FC; color: rgba(196,82,92,0.9); cursor: pointer; display: inline-flex;
  align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0;
}
.dir-iconbtn:hover { background: rgba(196,82,92,0.1); }
.dir-listrow {
  display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 9px;
  font-size: 13px; color: #1E2A45; cursor: pointer;
}
.dir-listrow:hover { background: rgba(30,42,74,0.05); }
.dir-listrow--active { background: rgba(87,183,146,0.12); }
.dir-gselect {
  height: 36px; border: 1px solid rgba(255,255,255,0.65); border-radius: 10px; padding: 0 12px;
  font-size: 13px; color: #2B2F3A; background: rgba(255,255,255,0.55);
  backdrop-filter: blur(20px) saturate(150%); -webkit-backdrop-filter: blur(20px) saturate(150%);
  box-shadow: 0 2px 8px rgba(30,42,74,0.06); cursor: pointer; outline: none;
}

/* ── Панель фильтров ── */
.dir-filterwrap { position: relative; z-index: 15; margin: 10px 32px 0; }
.dir-filter-backing {
  position: absolute; inset: 0;
  background: linear-gradient(160deg, rgba(255,255,255,0.82), rgba(255,255,255,0.6));
  backdrop-filter: blur(24px) saturate(160%); -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.65); border-radius: 14px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.5), 0 6px 18px rgba(30,42,74,0.06); pointer-events: none;
}
.dir-filter-inner {
  position: relative; padding: 8px 12px; display: flex; align-items: center; gap: 6px;
  flex-wrap: nowrap; overflow-x: auto;
}
.dir-chip {
  display: inline-flex; align-items: center; gap: 5px; height: 34px; padding: 0 9px;
  border: 1px solid rgba(255,255,255,0.65); border-radius: 9px; background: rgba(255,255,255,0.55);
  backdrop-filter: blur(20px) saturate(150%); -webkit-backdrop-filter: blur(20px) saturate(150%);
  box-shadow: 0 2px 8px rgba(30,42,74,0.06); color: #2B2F3A; font-size: 12px; font-weight: 500;
  cursor: pointer; white-space: nowrap; flex-shrink: 0;
}
.dir-chip--active { border-color: rgba(87,183,146,0.6); }
.dir-menu {
  position: absolute; top: 38px; left: 0; z-index: 20; background: rgba(255,255,255,0.75);
  backdrop-filter: blur(20px) saturate(180%); -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255,255,255,0.6); border-radius: 10px;
  box-shadow: 0 8px 24px rgba(20,25,40,0.18); padding: 6px; min-width: 220px;
  max-height: 280px; overflow-y: auto;
}
.dir-menu-item {
  display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-radius: 7px;
  font-size: 12px; color: #2B2F3A; cursor: pointer;
}
.dir-menu-item:hover { background: rgba(30,42,74,0.05); }
.dir-menu-count { margin-left: auto; font-size: 11px; color: rgba(30,42,74,0.45); }
.dir-segment {
  display: flex; align-items: center; background: rgba(255,255,255,0.55);
  backdrop-filter: blur(20px) saturate(150%); -webkit-backdrop-filter: blur(20px) saturate(150%);
  box-shadow: 0 2px 8px rgba(30,42,74,0.06); border: 1px solid rgba(255,255,255,0.65);
  border-radius: 9px; padding: 3px; gap: 2px; height: 34px; box-sizing: border-box; flex-shrink: 0;
}
.dir-segment-btn {
  height: 28px; padding: 0 10px; border: none; border-radius: 7px; background: transparent;
  color: #2B2F3A; font-size: 12px; font-weight: 500; cursor: pointer; white-space: nowrap;
}
.dir-segment-btn--active { background: #1E2A45; color: #FFFFFF; }
.dir-reset {
  height: 34px; padding: 0 10px; margin-left: auto; border: 1px solid rgba(30,42,74,0.10);
  border-radius: 9px; background: rgba(255,255,255,0.55); color: rgba(30,42,74,0.6);
  font-size: 12px; font-weight: 500; cursor: pointer; white-space: nowrap; flex-shrink: 0;
}

/* ── Контент / таблица ── */
.dir-content {
  flex: 1; min-height: 0; display: flex; flex-direction: column; gap: 12px; padding: 20px 32px 24px;
}
.dir-selbar {
  flex-shrink: 0; display: flex; align-items: center; gap: 10px; height: 44px; padding: 0 14px;
  border-radius: 10px; background: #1E2A45; box-shadow: 0 4px 14px rgba(30,42,74,0.2);
}
.dir-selbar-text { font-size: 13px; font-weight: 600; color: #FFFFFF; white-space: nowrap; }
.dir-selbar-sep { width: 1px; height: 20px; background: rgba(255,255,255,0.2); }
.dir-selbar-x {
  margin-left: auto; width: 28px; height: 28px; border: none; border-radius: 7px;
  background: transparent; color: rgba(255,255,255,0.7); font-size: 15px; cursor: pointer;
}
.dir-selbar-x:hover { background: rgba(255,255,255,0.12); color: #FFFFFF; }
.dir-tablewrap { position: relative; flex: 1; min-height: 0; }
.dir-card {
  position: relative; height: 100%; display: flex; flex-direction: column;
  background: rgba(255,255,255,0.55); backdrop-filter: blur(20px) saturate(150%);
  -webkit-backdrop-filter: blur(20px) saturate(150%); border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.65); box-shadow: 0 2px 8px rgba(30,42,74,0.06); overflow: hidden;
}
.dir-scroll { position: relative; flex: 1; min-height: 0; overflow-y: auto; }
.dir-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.dir-th {
  padding: 10px; font-size: 12px; font-weight: 600; text-align: left; position: sticky; top: 0;
  background: #F5F7FB; z-index: 3; user-select: none; color: rgba(30,42,74,0.55);
}
.dir-th--sortable { cursor: pointer; }
.dir-tr { height: 44px; border-top: 1px solid rgba(30,42,74,0.06); }
.dir-tr:hover { background: rgba(30,42,74,0.025); }
.dir-td { padding: 6px 10px; overflow: hidden; font-size: 13px; color: #1E2A45; }
.dir-name { font-size: 13px; font-weight: 600; color: #1E2A45; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.dir-catchip {
  display: inline-flex; align-items: center; font-size: 10.5px; font-weight: 600; color: #3E8C6C;
  background: rgba(87,183,146,0.1); padding: 2px 7px; border-radius: 999px; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis; max-width: 100%;
}
.dir-archive-pill {
  font-size: 10px; font-weight: 700; color: rgba(30,42,74,0.5); background: rgba(30,42,74,0.08);
  padding: 2px 6px; border-radius: 999px; flex-shrink: 0;
}
.dir-muted { color: rgba(30,42,74,0.6); }
.dir-tabnum { font-variant-numeric: tabular-nums; }
.dir-sm { font-size: 12.5px; }
.dir-empty { padding: 60px 20px; text-align: center; font-size: 14px; color: rgba(30,42,74,0.45); }
.dir-footer {
  flex-shrink: 0; display: flex; align-items: center; gap: 16px; padding: 10px 16px;
  border-top: 1px solid rgba(30,42,74,0.07); background: rgba(255,255,255,0.5);
}
.dir-footer-text { font-size: 12.5px; color: rgba(30,42,74,0.6); }

/* ── Поповер навбара (список справочников) ── */
.dir-navpop {
  background: rgba(255,255,255,0.98); backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%); border: 1px solid rgba(255,255,255,0.7);
  border-radius: 12px; box-shadow: 0 12px 32px rgba(20,25,40,0.22); padding: 6px; min-width: 232px;
}
.dir-navpop-item {
  display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 8px;
  font-size: 12px; font-weight: 500; color: #2B2F3A; cursor: pointer; text-decoration: none;
}
.dir-navpop-item:hover { background: rgba(30,42,74,0.05); }
.dir-navpop-item--active { background: rgba(87,183,146,0.12); color: #1E2A45; }
.dir-navpop-badge {
  width: 28px; height: 28px; border-radius: 8px; background: rgba(87,183,146,0.12);
  display: flex; align-items: center; justify-content: center; color: #3E8C6C; flex-shrink: 0;
}

/* ── Модалка (create/edit/import/merge) ── */
.dir-modal-backdrop {
  position: fixed; inset: 0; z-index: 1000; display: flex; align-items: center;
  justify-content: center; padding: 24px; background: rgba(20,25,40,0.35);
  backdrop-filter: blur(2px);
}
.dir-modal {
  width: 560px; max-width: 100%; max-height: 90vh; display: flex; flex-direction: column;
  background: #FFFFFF; border-radius: 20px; box-shadow: 0 30px 80px rgba(20,25,40,0.35);
  overflow: hidden;
}
.dir-modal--wide { width: 760px; }
.dir-modal-head {
  flex-shrink: 0; display: flex; align-items: center; gap: 10px; padding: 16px 20px;
  border-bottom: 1px solid rgba(30,42,74,0.08);
}
.dir-modal-title { font-size: 16px; font-weight: 700; color: #1E2A45; }
.dir-modal-body { flex: 1; min-height: 0; overflow-y: auto; padding: 18px 20px; }
.dir-modal-foot {
  flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding: 14px 20px; border-top: 1px solid rgba(30,42,74,0.08); background: rgba(248,247,252,0.6);
}
.dir-x {
  margin-left: auto; width: 30px; height: 30px; border: none; border-radius: 8px;
  background: transparent; color: rgba(30,42,74,0.5); font-size: 17px; cursor: pointer;
}
.dir-x:hover { background: rgba(30,42,74,0.06); color: #1E2A45; }

/* ── Форма ── */
.dir-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 14px; }
.dir-field { display: flex; flex-direction: column; gap: 5px; grid-column: 1 / -1; }
.dir-field--half { grid-column: auto; }
.dir-flabel { font-size: 12px; font-weight: 600; color: rgba(30,42,74,0.6); }
.dir-input, .dir-textarea, .dir-fselect {
  width: 100%; box-sizing: border-box; border: 1px solid rgba(30,42,74,0.14);
  border-radius: 9px; padding: 0 12px; height: 38px; font-size: 13px; color: #1E2A45;
  background: #F8F7FC; outline: none;
}
.dir-textarea { height: auto; min-height: 76px; padding: 9px 12px; resize: vertical; }
.dir-input:focus, .dir-textarea:focus, .dir-fselect:focus { border-color: #3E8C6C; background: #FFFFFF; }
.dir-check { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #1E2A45; cursor: pointer; }
.dir-mf-row { display: flex; gap: 8px; margin-bottom: 6px; }
.dir-mf-row .dir-input { flex: 1; }
.dir-mf-type { width: 110px; flex-shrink: 0; }
.dir-mf-del {
  width: 38px; flex-shrink: 0; border: 1px solid rgba(30,42,74,0.14); border-radius: 9px;
  background: #F8F7FC; color: rgba(196,82,92,0.9); cursor: pointer; font-size: 15px;
}
.dir-mf-add {
  border: 1px dashed rgba(30,42,74,0.2); border-radius: 9px; background: transparent;
  color: #3E8C6C; font-size: 12.5px; font-weight: 600; padding: 7px 10px; cursor: pointer;
}

/* ── Меню действий строки ── */
.dir-actions-btn {
  width: 28px; height: 28px; border: none; border-radius: 7px; background: transparent;
  color: rgba(30,42,74,0.55); cursor: pointer; display: inline-flex; align-items: center;
  justify-content: center;
}
.dir-actions-btn:hover { background: rgba(30,42,74,0.06); color: #1E2A45; }
.dir-rowmenu {
  position: fixed; z-index: 1000; min-width: 190px; padding: 6px; border-radius: 10px;
  background: #FFFFFF; border: 1px solid rgba(30,42,74,0.1);
  box-shadow: 0 12px 32px rgba(20,25,40,0.2);
}
.dir-rowmenu-item {
  display: flex; align-items: center; gap: 9px; padding: 8px 10px; border-radius: 7px;
  font-size: 13px; color: #2B2F3A; cursor: pointer; white-space: nowrap;
}
.dir-rowmenu-item:hover { background: rgba(30,42,74,0.05); }
.dir-rowmenu-item--danger { color: #C4525C; }
.dir-rowmenu-item--danger:hover { background: rgba(196,82,92,0.08); }
.dir-rowmenu-sep { height: 1px; margin: 5px 4px; background: rgba(30,42,74,0.08); }

/* ── Дровер карточки ── */
.dir-drawer-backdrop { position: fixed; inset: 0; z-index: 999; background: rgba(20,25,40,0.3); }
.dir-drawer {
  position: fixed; top: 0; right: 0; bottom: 0; z-index: 1000; width: 560px; max-width: 100%;
  display: flex; flex-direction: column; background: #FFFFFF; box-shadow: -12px 0 40px rgba(20,25,40,0.22);
}
.dir-drawer-head {
  flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding: 16px 20px;
  border-bottom: 1px solid rgba(30,42,74,0.08);
}
.dir-tabs { flex-shrink: 0; display: flex; gap: 2px; padding: 8px 12px 0; overflow-x: auto; border-bottom: 1px solid rgba(30,42,74,0.08); }
.dir-tab {
  border: none; background: transparent; padding: 8px 12px; border-radius: 8px 8px 0 0;
  font-size: 12.5px; font-weight: 600; color: rgba(30,42,74,0.55); cursor: pointer; white-space: nowrap;
}
.dir-tab--active { color: #1E2A45; background: rgba(87,183,146,0.1); }
.dir-drawer-body { flex: 1; min-height: 0; overflow-y: auto; padding: 16px 20px; }
.dir-kv { display: grid; grid-template-columns: 150px 1fr; gap: 7px 12px; }
.dir-k { font-size: 12.5px; color: rgba(30,42,74,0.5); }
.dir-v { font-size: 13px; color: #1E2A45; word-break: break-word; }
.dir-sec-title { font-size: 12px; font-weight: 700; color: rgba(30,42,74,0.5); text-transform: uppercase; letter-spacing: 0.03em; margin: 4px 0 8px; }
.dir-subrow {
  display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 9px;
  border: 1px solid rgba(30,42,74,0.08); margin-bottom: 6px; font-size: 13px; color: #1E2A45;
}
.dir-subrow-sub { font-size: 11.5px; color: rgba(30,42,74,0.5); }
.dir-add-link {
  border: 1px dashed rgba(30,42,74,0.2); border-radius: 9px; background: transparent;
  color: #3E8C6C; font-size: 12.5px; font-weight: 600; padding: 8px 10px; cursor: pointer; width: 100%;
}
.dir-hist { display: flex; gap: 10px; padding: 8px 0; border-top: 1px solid rgba(30,42,74,0.06); font-size: 12.5px; }
.dir-hist-dot { width: 7px; height: 7px; border-radius: 50%; background: #3E8C6C; margin-top: 5px; flex-shrink: 0; }
.dir-empty-sm { padding: 24px; text-align: center; font-size: 13px; color: rgba(30,42,74,0.45); }
`;

/** Единый скоупленный <style> для модуля. Рендерится один раз в корне страницы
 *  и в портале поповера (оба узла получают className="dir-scope"). */
export function DirStyles() {
  return <style>{CSS}</style>;
}
